// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"83":"async-lottie","349":"async-null","979":"async-mermaid"}[chunkId] + ".js";
};